import { getCurrentInstance, watch } from "@vue/composition-api";
import { InputUserGeolocation, UserPublicInformation } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { MUTATION_TYPES } from "@/store/const";
import providers from "@/lib/api";
import { IS_BROWSER } from "@/lib/browserUtils";

export function updateHasLocation(data: UserPublicInformation, vm: ReturnType<typeof getCurrentInstance>) {
  const hasLocation = !!data.geolocation && data.geolocation?.latitude !== 0 && data.geolocation?.longitude !== 0;

  vm?.$store.commit(MUTATION_TYPES.SET_STATE, {
    hasLocation,
  });
}

export function useGeolocation() {
  const vm = getCurrentInstance();
  const { authUser, authUserStrict, isAnyCreator } = useAuthUser();

  const updateGeolocation = async (data: InputUserGeolocation) => {
    const response = await providers.UserPublicDataProvider.userPublicInformationUpdate({
      userId: authUserStrict.value.id,
      geolocation: data,
    });
    updateHasLocation(response, vm);
  };

  const getGeolocation = async () => {
    IS_BROWSER &&
      navigator.geolocation.getCurrentPosition(
        position => {
          const { latitude, longitude } = position.coords;
          updateGeolocation({ latitude, longitude, enabled: true });
        },
        error => {
          console.error(error);
          updateGeolocation({ latitude: 0, longitude: 0, enabled: false });
        },
        {
          enableHighAccuracy: true,
          timeout: Infinity,
          maximumAge: 0,
        }
      );
  };

  watch(
    authUser,
    (newVal, oldVal) => {
      if (isAnyCreator.value && newVal?.id !== oldVal?.id) {
        getGeolocation();
      }
    },
    { immediate: true }
  );
}
